<div class="icon mr-3">
  <fa-icon [icon]="faFileDownload" size="lg" *ngIf="(downloading$ | async) === false; else spinner"></fa-icon>
</div>

<ng-template #spinner>
  <mat-spinner [diameter]="20"></mat-spinner>
</ng-template>
